<template>
  <div class="hint-box">
    <div class="hint-box__number">
      {{ number }}
    </div>
    <div class="hint-box__body">
      <slot />
    </div>
  </div>
</template>
<script>
  export default {
    props: ['number']
  }
</script>


<style lang="scss" scoped>
  .hint-box
  {
    margin: 20px 0;

    &__number
    {
      font-size: 51px;
      font-weight: bold;
      line-height: 40px;

      margin-bottom: 15px;

      color: #e2173d;
    }

    &__body
    {
      font-size: 17px;
      line-height: 25px;

      color: #fff;
    }
  }
</style>
